import React, { ReactElement } from 'react';
import { FdrImage } from '@hotelplan/supergraph-api';
import { FdrBlogDate } from './fdr-blog-date';
import {
  FdrAuthorDisrupterContent,
  FdrAuthorDisrupterWrapper,
  FdrAuthorImage,
  FdrAuthorText,
} from './fdr-blog-overview.styles';

interface IFdrAuthorDisrupterProps {
  image: FdrImage;
  name: string;
  date?: string;
  className?: string;
}

export function FdrAuthorDisrupter({
  name,
  date,
  image,
  className,
}: IFdrAuthorDisrupterProps): ReactElement {
  return (
    <FdrAuthorDisrupterWrapper className={className}>
      <FdrAuthorDisrupterContent>
        {image ? <FdrAuthorImage image={image} /> : null}
        <FdrAuthorText>
          <p className="employee-name">{name}</p>
          {date ? (
            <span>
              <FdrBlogDate date={date} />
            </span>
          ) : null}
        </FdrAuthorText>
      </FdrAuthorDisrupterContent>
    </FdrAuthorDisrupterWrapper>
  );
}
